// extracted by mini-css-extract-plugin
export default {"pattern-gradient":"Signup_pattern-gradient__tK0T3","page":"Signup_page__IHuJA","box":"Signup_box__l6Gti","component":"Signup_component__LIiAk","login":"Signup_login__YKNjm"};